var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',{staticClass:"stage-stamp"},[_vm._v(_vm._s(_vm.labelText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }